export const ProjectItems = {
    'latestProjects': [
        {
            name: 'Driving Alerts Toronto',
            time: 'October 2021',
            logo: 'driving-alerts-toronto.png',
            descriptionItems: [
                'A Cross-platform mobile app designed to make use of data provided by the City of Toronto to notify users of Red Light Cameras and Automated Speed Enforcement Cameras in realtime.',
                'Links to datasets provided by the city of Toronto: <a href="https://open.toronto.ca/dataset/red-light-cameras/" target="_blank"><b>Red Light Camera</b></a> and <a href="https://open.toronto.ca/dataset/automated-speed-enforcement-locations/" target="_blank"><b>Automated Speed Enforcement Cameras</b></a>.',
                'Tech Stack: React Native, Expo, Javascript',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/drive-safe-toronto" target="_blank"><b>here</b></a>.',
                'You may check out some screenshots of the app <a href="https://drive.google.com/drive/folders/13twjEOK-7zWrkATZnBRQPRIspVlJ7G_p" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'Portfolio Website',
            time: 'December 2021',
            logo: 'website-logo.png',
            descriptionItems: [
                'A light, interactive and responsive website which showcases my Projects, Experience, Education and Awards.',
                'This Portfolio Website is an updated version from my legacy site which was coded in basic HTML, CSS, Javascript. This site uses the React framework to make a polished and responsive UI/UX optimized for both Desktops and Mobile browsers.',
                'Tech Stack: React, JavaScript, CSS, HTML',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/parth-commits.github.io" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'Starbucks Rewards',
            time: 'Summer 2021',
            logo: 'sb-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their Rewards Card at Starbucks and get Stars (points) right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by Starbucks itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Further optimized the user flow by creating a widget that the user can add to the home screen of their watch to improve time taken to scan their Rewards code by <b>90%</b>. You can checkout the widget version of app <a href="https://galaxy.store/widgetsb" target="_blank"> <b> here</b></a>.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'Currently has over <b class="confetti-items">30,000</b> downloads!',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/starbucks" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/SB-test/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/SB-test" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'Starbucks Scan + Pay',
            time: 'Summer 2021',
            logo: 'sbscanpay-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their Starbucks Card at Starbucks and get 2x Stars (points) and pay for their bill right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by Starbucks itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Further optimized the user flow by creating a widget that the user can add to the home screen of their watch to improve time taken to scan their Rewards code by <b>90%</b>. You can checkout the widget version of app <a href="https://galaxy.store/kmowkxoyi" target="_blank"> <b> here</b></a>.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/sqadoxczl" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/SB-Scan-and-Pay/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/SB-Scan-and-Pay" target="_blank"><b>here</b></a>',
            ],
        },
    ],
    'mobileProjects': [
        {
            name: 'Driving Alerts Toronto',
            time: 'October 2021',
            logo: 'driving-alerts-toronto.png',
            descriptionItems: [
                'A Cross-platform mobile app designed to make use of data provided by the City of Toronto to notify users of Red Light Cameras and Automated Speed Enforcement Cameras in realtime.',
                'Links to datasets provided by the city of Toronto: <a href="https://open.toronto.ca/dataset/red-light-cameras/" target="_blank"><b>Red Light Camera</b></a> and <a href="https://open.toronto.ca/dataset/automated-speed-enforcement-locations/" target="_blank"><b>Automated Speed Enforcement Cameras</b></a>.',
                'Tech Stack: React Native, Expo, Javascript',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/drive-safe-toronto" target="_blank"><b>here</b></a>.',
                'You may check out some screenshots of the app <a href="https://drive.google.com/drive/folders/13twjEOK-7zWrkATZnBRQPRIspVlJ7G_p" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'Work Log',
            time: 'October 2021',
            logo: 'worklog-icon.png',
            descriptionItems: [
                'A Cross-platform mobile app designed to allow users to log their work hours (or hours for any other occasion) to see a total of how much they spent per month.',
                'Key features: Lets users export the data as an Excel file so they can use it for accounting purposes or any other reason they feel necessary.',
                'Tech Stack: React Native, Expo, Javascript',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/worklog" target="_blank"><b>here</b></a>.',
                'You may check out some screenshots of the app <a href="https://drive.google.com/drive/folders/14DlnzOdhNmRo1pghKzMQgDhr2zRgD6D6" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'COVID-19 Live Data App',
            time: 'August 2020',
            logo: 'covidlivedata.png',
            descriptionItems: [
                'App that shows the basic info on the latest COVID-19 statistics for some selected countries.',
                'This app can potentially speed up time taken to check the stats by <b>50%</b> compared to using traditional COVID statistics providing sites.',
                'Goal of project: create a clean fast to use app to see latest COVID stats.',
                'Tech Stack: Java, Android',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/Coronavirus" target="_blank"><b>here</b></a>.',
                'You may check out some screenshots of the app <a href="https://drive.google.com/drive/folders/14fuR2KHR999SG-ThkIfdW7WcwD1Woevd" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'Jokes Generator',
            time: 'December 2020',
            logo: 'jokes generator.png',
            descriptionItems: [
                'Quick Android App designed to refresh with a new joke every time you refresh the screen.',
                'Goal of app: create a quick fast to use app to see random jokes. App made in under 1 day.',
                'Tech Stack: Java, Android',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/jokes-generator" target="_blank"><b>here</b></a>.',
            ],
        },
    ],
    'wearableProjects': [
        {
            name: 'Starbucks Rewards',
            time: 'Summer 2021',
            logo: 'sb-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their Rewards Card at Starbucks and get Stars (points) right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by Starbucks itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Further optimized the user flow by creating a widget that the user can add to the home screen of their watch to improve time taken to scan their Rewards code by <b>90%</b>. You can checkout the widget version of app <a href="https://galaxy.store/widgetsb" target="_blank"> <b> here</b></a>.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'Currently has over <b class="confetti-items">30,000</b> downloads!',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/starbucks" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/SB-test/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/SB-test" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'PC Points',
            time: 'December 2021',
            logo: 'pcpoints-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their PC Optimum Rewards Card and get points right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by the brand PC itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Further optimized the user flow by creating a widget that the user can add to the home screen of their watch to improve time taken to scan their Rewards code by <b>90%</b>.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/pcpoints" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/pc-rewards/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/pc-rewards" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'Starbucks Scan + Pay',
            time: 'Summer 2021',
            logo: 'sbscanpay-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their Starbucks Card at Starbucks and get 2x Stars (points) and pay for their bill right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by Starbucks itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Further optimized the user flow by creating a widget that the user can add to the home screen of their watch to improve time taken to scan their Rewards code by <b>90%</b>. You can checkout the widget version of app <a href="https://galaxy.store/kmowkxoyi" target="_blank"> <b> here</b></a>.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/sqadoxczl" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/SB-Scan-and-Pay/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/SB-Scan-and-Pay" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'Tims Rewards',
            time: 'Summer 2021',
            logo: 'timsrewards-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users that can be used to scan their Rewards Card at Tim Hortons and get rewards points right from their watch.',
                'Goal of project: to create a minimalistic UI for users to use all the while making it feel as if it was made by Tim Hortons itself! <b> (Legal Disclaimer: It\'s not!)</b>',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/tims1" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/TH-test/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/TH-test" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'Tic Tac Toe',
            time: 'Summer 2021',
            logo: 'tictactoe-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users to play Tic Tac Toe.',
                'Goal of project: to create a minimalistic UI for users to enjoy playing Tic Tac Toe with a friend when they are bored.',
                'Key feature included is board rotates so your friend gets the same view as you while playing without you having to perform gymnastics with your hands.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/tic1" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/TicTacToe-watch-app/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/TicTacToe-watch-app" target="_blank"><b>here</b></a>',
            ],
        },
        {
            name: 'Sudoku',
            time: 'Summer 2021',
            logo: 'sudoku-wApp.png',
            descriptionItems: [
                'App for Samsung Galaxy Watch users to play Sudoku in 3 modes - Easy, Medium and Hard. ',
                'Goal of project: to create a minimalistic UI for users to enjoy playing Sudoku.',
                'Tech Stack: HTML, CSS, and VanillaJS, Tizen web framework.',
                'You may visit the Galaxy Store link <a href="https://galaxy.store/sudoku3" target="_blank"> <b> here</b></a>.',
                'You may try a demo <a href="https://parth-commits.github.io/sudoku-watch-app/" target="_blank"> <b> here</b></a>.',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/sudoku-watch-app" target="_blank"><b>here</b></a>',
            ],
        },
    ],
    'otherProjects': [
        {
            name: 'Portfolio Website',
            time: 'December 2021',
            logo: 'website-logo.png',
            descriptionItems: [
                'A light, interactive and responsive website which showcases my Projects, Experience, Education and Awards.',
                'This Portfolio Website is an updated version from my legacy site which was coded in basic HTML, CSS, Javascript. This site uses the React framework to make a polished and responsive UI/UX optimized for both Desktops and Mobile browsers.',
                'Tech Stack: React, JavaScript, CSS, HTML',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/parth-commits.github.io" target="_blank"><b>here</b></a>.',
            ],
        },
        {
            name: 'Conference Management System',
            time: 'Sept - Dec 2020',
            logo: 'conference-icon.png',
            descriptionItems: [
                'A backend school project made in the Software Design course (CSC207) at the University of Toronto in a small to medium sized team.',
                'Implemented a design of this program that follows Clean Architecture and SOLID principles as well as design patterns.',
                'This program is a simulation of a backend Tech Conference Management System. There are multiple type of accounts (Attendee, Speaker, Admin) that have access to do different things.',
                'As this is a backend project, there is no UI, and instead uses the console.',
                'Tech Stack: Java',
                'You may check out the code on GitHub <a href="https://github.com/parth-commits/conference-system" target="_blank"><b>here</b></a>.',
            ],
        },
    ],
};
